import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
//引入富文本插件
import VueQuillEditor from 'vue-quill-editor'
//复制插件
import VueClipboard from 'vue-clipboard2'

//maxWindow.js
import './assets/js/maxWindow'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);
// 

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);

//引入cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// 使用VueClipboard 剪切板
Vue.use(VueClipboard);

// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})


// 路由拦截器
router.beforeEach((to, from, next) => {
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag && to.path != "/login" && to.path!="/login/forgetPassword" && to.path!="/register" ){
        window.location.replace(window.location.protocol+"//"+window.location.host+'/mobile');
    }else if(flag && to.path == "/login" ){
        next()
    }else{
        // document.title = `${to.name} | 华万控制台`;
        if(to.meta.requireAuth && !localStorage.getItem("logintoken")) { // 判断该路由是否需要登录权限
            next({
                path: '/login'
            })
        }else if(localStorage.getItem("logintoken") && to.path === "/login"){
            next({
                path: '/'
            })
        }else{
            next()
        }
    }
   
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js